module.exports = "data:image/gif;base64,R0lGODlhBwAHAIAAAA4ODgAAACH5BAAAAAAALAAAAAAHAAcAAAIGhI+py40FADs="